import { NativeDateAdapter } from "@angular/material/core";

export class CustomDateAdapter extends NativeDateAdapter {
  parse(value: any): Date | null {
    const dateRegex = /[0-3]?[0-9][ ]?[\./][ ]?[0-1]?[0-9][ ]?[\./][ ]?[0-9]+/;
    if (typeof value !== "string" || !dateRegex.test(value)) {
      return super.parse(value);
    }

    let split = value.split(".");
    if (split.length !== 3) {
      split = value.split("/");
    }

    if (split.length !== 3) {
      return super.parse(value);
    }

    const year = Number(split[2].trim());
    const month = Number(split[1].trim()) - 1;
    const date = Number(split[0].trim());
    return new Date(year, month, date);
  }
}
